import React, { useState, useEffect } from "react";
import { useInput } from "../../../components/hooks/useInput";
import { HalfCircleSpinner } from "react-epic-spinners";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../../utils/requests";
import collieImage from "../../../assets/images/CollieAsset.png";
import poImage from "../../../assets/images/pO.png";
import {
  API_ENDPOINT_URL,
  AUTH_PREFIX,
  GOOGLE_KEY,
  RECAPTCHA_SITE_KEY,
} from "../../../utils/appConstants";
import { enforceFormat, formatToPhone, validatePassword } from "../../../utils";
import { Helmet } from "react-helmet-async";
import { Wrapper } from "@googlemaps/react-wrapper";
import { Map } from "../../../components/shared/map/map.component";
import { toast } from "react-toastify";

const ConfVetSignup = (props) => {
  const [firstName, bindFirstName] = useInput("");
  const [lastName, bindLastName] = useInput("");
  const [phone, bindPhone] = useInput("+44");
  const [email, bindEmail] = useInput("");
  const [password, bindPassword] = useInput("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, bindConfirmPassword] = useInput("");
  const [showCP, setShowCP] = useState(false);
  const [errors, setErrors] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const captchaScript = document.createElement("script");
    captchaScript.src = "https://www.google.com/recaptcha/api.js";
    captchaScript.async = true;
    captchaScript.defer = true;
    document.body.appendChild(captchaScript);
    props?.captcha?.setIsCaptchaValid(false);
    return () => {
      document.body.removeChild(captchaScript);
    };
  }, []);

  // validation
  const validateForm = () => {
    let errors = {};
    let isValid = true;
    const vp = validatePassword(password);

    if (!firstName) {
      isValid = false;
      errors["firstName"] = "This filed is required.";
    }
    if (!lastName) {
      isValid = false;
      errors["lastName"] = "This filed is required.";
    }
    if (!phone) {
      isValid = false;
      errors["phone"] = "This filed is required.";
    }
    if (phone) {
      let res = phone.replace(/\D/g, "");
      if (res.length < 10) {
        isValid = false;
        errors["phone"] = "Please enter a Valid Phone number.";
      }
    }
    if (!email) {
      isValid = false;
      errors["email"] = "This filed is required.";
    }
    if (email) {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(email)) {
        isValid = false;
        errors["email"] = "Please enter valid email address.";
      }
    }
    if (!vp.isValid) {
      isValid = false;
      errors["password"] = vp.message;
    }
    if (!password) {
      isValid = false;
      errors["password"] = "This filed is required.";
    }
    if (password !== confirmPassword) {
      isValid = false;
      errors["matchPassword"] = "Passwords do not match.";
    }
    setErrors(errors);
    return isValid;
  };

  //Send the data on form submission
  const signUpHandler = async (event) => {
    event.preventDefault();
    if (validateForm() && props?.captcha?.isCaptchaValid) {
      try {
        setShowLoader(true);

        let unformmatedPhone = phone
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll("-", "")
          .replaceAll(" ", "");

        let requestBody = {
          first_name: firstName,
          last_name: lastName,
          phone_number: unformmatedPhone,
          email,
          password,
          password_confirmation: confirmPassword,
          conf: true,
        };

        postRequest(
          `${API_ENDPOINT_URL}/register/veterinarian`,
          requestBody
        ).then((res) => {
          if (res) {
            props?.captcha?.setIsCaptchaValid(false);
            localStorage.setItem(
              "currentUser",
              JSON.stringify(res.data.data.user)
            );
            localStorage.setItem("access_token", res.data.data.access_token);
            setShowLoader(false);
            navigate(`${AUTH_PREFIX}/signup-congrats`);
          } else {
            setShowLoader(false);
          }
        })
        .finally(() => {
          setShowLoader(false);
        });
      } catch (err) {
        console.log(err);
        toast.error("Unable to validate address.");
        setShowLoader(false);
      }
    }
  };

  return (
    <section className="um-sectionWrap um-charityFormBlock pt-5 pb-5">
      <Helmet>
        <title>
          Register as a PetBond Recommended Vet and Link to new advert in
          Laravel (advert to be imported)ise your clinic for free
        </title>
        <meta
          name="description"
          content="Simply fill in the form to register as a PetBond Recommended Vet and reach over 30,000 visitors a month. Together we can improve animal welfare."
        />
      </Helmet>
      <div className="container">
        <div className="um-bdShadowComp shadow rounded-lg">
          <img
            src={poImage}
            alt="PetBond"
            className="img-fluid"
            style={{
              width: "100px",
              position: "absolute",
              left: 0,
              right: 0,
              margin: "auto",
              textAlign: "center",
              top: "-30px",
            }}
          />
          <div className="um-formBrdd">
            <form
              className="um-bddFormWrap"
              onSubmit={(event) => signUpHandler(event)}
            >
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h1 className="h4 text-center">
                    Vet Teams, prevent needless suffering for generations of
                    pets like me!
                  </h1>
                  <div className="text-center">
                    <img
                      src={collieImage}
                      alt="Collie"
                      className="img-fluid mt-3 mb-4"
                      style={{ maxWidth: "250px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <label className="um-bddFormlb">Your details:</label>
                  <div className="form-group um-bddInputWrap">
                    <input
                      type="text"
                      id="first_name"
                      placeholder="First Name&hellip;"
                      className={`form-control w-100 ${
                        errors?.firstName && "fcError"
                      }`}
                      {...bindFirstName}
                    />
                    {errors.firstName && (
                      <small className="support-error">
                        {errors.firstName}
                      </small>
                    )}
                  </div>
                  <div className="form-group um-bddInputWrap">
                    <input
                      type="text"
                      id="last_name"
                      placeholder="Last Name&hellip;"
                      className={`form-control w-100 ${
                        errors?.lastName && "fcError"
                      }`}
                      {...bindLastName}
                    />
                    {errors.lastName && (
                      <small className="support-error">{errors.lastName}</small>
                    )}
                  </div>
                  <div className="form-group um-bddInputWrap">
                    <input
                      type="tel"
                      id="phone"
                      placeholder="Mobile&hellip;"
                      className={`form-control w-100 ${
                        errors?.phone && "fcError"
                      }`}
                      maxLength={20}
                      onKeyUp={formatToPhone}
                      onKeyDown={enforceFormat}
                      {...bindPhone}
                    />
                    {errors.phone && (
                      <small className="support-error">{errors.phone}</small>
                    )}
                  </div>
                  <div className="form-group um-bddInputWrap">
                    <input
                      type="email"
                      id="email"
                      placeholder="Email&hellip;"
                      className={`form-control w-100 ${
                        errors?.email && "fcError"
                      }`}
                      {...bindEmail}
                    />
                    {errors.email && (
                      <small className="support-error">{errors.email}</small>
                    )}
                  </div>
                  <div className="um-chrtFormInfii">
                    <div className="form-group um-bddInputWrap">
                      <div className="position-relative icnInputWrap">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          placeholder="Password"
                          className={`form-control w-100 ${
                            errors?.password && "fcError"
                          }`}
                          {...bindPassword}
                        />
                        {showPassword === false ? (
                          <i
                            className="far fa-eye-slash icn"
                            onClick={() => setShowPassword(true)}
                          />
                        ) : (
                          <i
                            className="far fa-eye icn"
                            onClick={() => setShowPassword(false)}
                          />
                        )}
                      </div>
                      <small>{props.passwordInfo}</small>
                      {errors.password && (
                        <small className="support-error">
                          {errors.password}
                        </small>
                      )}
                    </div>
                    <div className="form-group um-bddInputWrap">
                      <div className="position-relative icnInputWrap">
                        <input
                          type={showCP ? "text" : "password"}
                          id="confirmPassword"
                          placeholder="Confirm Password"
                          className={`form-control w-100 ${
                            errors?.confirmPassword && "fcError"
                          }`}
                          {...bindConfirmPassword}
                        />
                        {showCP === false ? (
                          <i
                            className="far fa-eye-slash icn"
                            onClick={() => setShowCP(true)}
                          />
                        ) : (
                          <i
                            className="far fa-eye icn"
                            onClick={() => setShowCP(false)}
                          />
                        )}
                      </div>
                      {errors.matchPassword && (
                        <small className="support-error">
                          {errors.matchPassword}
                        </small>
                      )}
                    </div>
                  </div>

                  <div
                    className="mt-2 g-recaptcha"
                    data-sitekey={RECAPTCHA_SITE_KEY}
                    data-callback="captchaConfirmation"
                  />

                  <div className="mt-2">
                    <button
                      type="submit"
                      className="btn btn-warning btn-block btnFormStyle btnFormWidth"
                      disabled={showLoader}
                    >
                      {showLoader && (
                        <HalfCircleSpinner
                          size={18}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                          }}
                        />
                      )}
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="mt-5">
          <a href="https://bvalive.vetshow.com/" target="_blank" rel="noreferrer">
            <img src="/images/bva/bva-join-us.png" alt="The Vet Show In Birmingham" className="w-100" />
          </a>
        </div>
      </div>
      <Wrapper apiKey={GOOGLE_KEY}>
        <Map
          center={{
            lat: 52.3555,
            lng: 1.1743,
          }}
          zoom={16}
          style={{ flexGrow: "1", height: "0%" }}
          options={"s"}
        ></Map>
      </Wrapper>
    </section>
  );
};

export default ConfVetSignup;
